import requestFunctions from "../../functions/requestFunctions";


export const state = {
  BOTS_CHANNELS_ITEM: {},
  BOTS_CHANNELS_LIST: [],
  BOTS_CHANNELS_TABLE_DATA: [],
  BOTS_CHANNELS_LIST_DATA: [],
  BOTS_CHANNELS_TOTAL_ROWS: 0
}

export const getters = {
  GET_BOTS_CHANNELS_ITEM: (state) => {
    return state.BOTS_CHANNELS_ITEM;
  },
  GET_BOTS_CHANNELS_LIST: (state) => {
    return state.BOTS_CHANNELS_LIST;
  },
  GET_BOTS_CHANNELS_TABLE_DATA: (state) => {
    return state.BOTS_CHANNELS_TABLE_DATA;
  },
  GET_BOTS_CHANNELS_LIST_DATA: (state) => {
    return state.BOTS_CHANNELS_LIST_DATA;
  },
  GET_BOTS_CHANNELS_TOTAL_ROWS: (state) => {
    return state.BOTS_CHANNELS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_BOTS_CHANNELS_ITEM(state, item) {
    state.BOTS_CHANNELS_ITEM = item;
  },

  UPDATE_BOTS_CHANNELS_LIST(state, list) {
    
    state.BOTS_CHANNELS_LIST = list.data;

    state.BOTS_CHANNELS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.BOTS_CHANNELS_TABLE_DATA = [];
    state.BOTS_CHANNELS_LIST_DATA = [];

    list.forEach(el => {

      state.BOTS_CHANNELS_TABLE_DATA.push({
        'channel_name': el.channel_name,
        'channel_code': el.channel_code,
        'channel_id': el.channel_id,
        'channel_fl_onlyone': el.channel_fl_onlyone,
        'channel_fl_default': el.channel_fl_default,
        'uuid' : el.uuid
      });

      state.BOTS_CHANNELS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        channel_name: el.channel_name,
        channel_code: el.channel_code,
        channel_fl_onlyone: el.channel_fl_onlyone,
        channel_fl_default: el.channel_fl_default,
        channel_id: el.channel_id,
      });

    });
  },
}

export const actions = {

  async FETCH_BOTS_CHANNELS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/channels/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BOTS_CHANNELS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_BOTS_CHANNELS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/channels';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BOTS_CHANNELS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_BOTS_CHANNELS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/channels';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_BOTS_CHANNELS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/channels/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_BOTS_CHANNELS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/channels/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}